const mediaItems = [
  {
    title: '顶流男星深夜密会神秘女子，酒店共度8小时',
    views: '128.6万',
    duration: '03:25',
    tag: '独家',
    img: 'https://readdy.ai/api/search-image?query=Blurred%20paparazzi%20style%20night%20scene%20of%20luxury%20hotel%20entrance%20with%20warm%20street%20lights%2C%20dramatic%20shadows%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20style%2C%20dark%20background%20with%20golden%20accent%20lighting%2C%20cinematic%20composition%2C%20no%20recognizable%20faces%2C%20abstract%20storytelling&width=800&height=600&seq=media-01-chigua&orientation=landscape'
  },
  {
    title: '知名网红直播间失言，品牌方连夜解约',
    views: '96.3万',
    duration: '05:12',
    tag: '热门',
    img: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20studio%20setup%20with%20professional%20lighting%20and%20camera%20equipment%2C%20warm%20moody%20atmosphere%2C%20empty%20chair%20in%20spotlight%2C%20dramatic%20contrast%2C%20editorial%20style%2C%20dark%20background%20with%20subtle%20red%20accents%2C%20cinematic%20lighting%2C%20professional%20broadcast%20aesthetic&width=800&height=600&seq=media-02-chigua&orientation=landscape'
  },
  {
    title: '综艺节目录制现场冲突，两导师当场翻脸',
    views: '87.1万',
    duration: '02:48',
    tag: '独家',
    img: 'https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20dramatic%20stage%20lighting%20and%20empty%20judges%20chairs%2C%20warm%20spotlights%20creating%20tension%2C%20professional%20broadcast%20environment%2C%20dramatic%20shadows%2C%20editorial%20style%2C%20dark%20theater%20background%20with%20red%20curtain%20accents%2C%20cinematic%20composition&width=800&height=600&seq=media-03-chigua&orientation=landscape'
  },
  {
    title: '女星走红毯礼服意外滑落，现场一片哗然',
    views: '75.8万',
    duration: '01:56',
    tag: '热门',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20event%20setup%20with%20golden%20stanchions%20and%20velvet%20ropes%2C%20dramatic%20paparazzi%20flash%20lighting%2C%20glamorous%20atmosphere%2C%20empty%20red%20carpet%20path%2C%20editorial%20style%2C%20luxurious%20event%20backdrop%20with%20brand%20logos%20blurred%2C%20cinematic%20lighting%2C%20warm%20golden%20tones&width=800&height=600&seq=media-04-chigua&orientation=landscape'
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">视频爆料</h2>
        <p className="text-sm text-foreground-500 mb-8">最新网红明星视频爆料，一睹为快</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/60 cursor-pointer hover:border-primary-200/60 transition-colors">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-background-50">{item.tag}</span>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded text-xs bg-black/60 text-background-50 flex items-center gap-1">
                  <i className="ri-play-fill text-xs"></i>
                  {item.duration}
                </span>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-1.5 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views} 次观看
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}